export const getGlobalBilly = () => window.Billy

export const getGlobalBillyScopes = () => getGlobalBilly().scopes

export const getGlobalBillyIsNewScopesVersion = () => getGlobalBilly().isNewScopesVersion

export const getGlobalBillyThemeLayoutMode = () => getGlobalBilly().themeLayoutMode

export const updateGlobalBillyScopes = () => getGlobalBilly().__container__?.lookup('service:auth').load()
